import {useTranslation} from 'react-i18next';
import {Controller, useFormContext} from 'react-hook-form';
import {GROUP_TYPES, SelectOption} from '@chekin/core';
import {getReservationTypeOptions} from '../utils';
import MultiRadio from 'components/common/MultiRadio';
import {ButtonConfirm, RadiosContainer} from '../styled';

type ReservationTypeSectionProps = {
  groupType: GROUP_TYPES;
  onSubmit: () => void;
  disabled?: boolean;
  radioCustomBox?: boolean;
  className?: string;
};

function ReservationTypeForm({
  groupType,
  onSubmit,
  disabled,
  radioCustomBox = false,
  className = '',
}: ReservationTypeSectionProps) {
  const {t} = useTranslation();
  const {control, handleSubmit} = useFormContext<{
    group_type?: SelectOption<undefined, GROUP_TYPES>;
  }>();
  const reservationTypeOptions = getReservationTypeOptions(t);
  const defaultGroupType = reservationTypeOptions.find(
    option => option.value === groupType,
  );
  const defaultOption =
    groupType !== GROUP_TYPES.single ? defaultGroupType : reservationTypeOptions[0];

  return (
    <div className={className}>
      <RadiosContainer>
        <Controller
          name="group_type"
          control={control}
          defaultValue={defaultOption}
          render={({field}) => (
            <MultiRadio
              disabled={false}
              options={reservationTypeOptions}
              {...field}
              isCustomBox={radioCustomBox}
            />
          )}
        />
      </RadiosContainer>
      <ButtonConfirm
        disabled={disabled}
        onClick={handleSubmit(onSubmit)}
        variant="primary"
      >
        {t('confirm')}
      </ButtonConfirm>
    </div>
  );
}

export {ReservationTypeForm};
